import { parseISO } from 'date-fns'

import { EDealType, EFlightDealType, EUserJourneyType } from '@pkg/lib-data'

const handleShowsDates = (eventDate?: string) => {
  if (!eventDate) {
    return null
  }

  const _eventDate = parseISO(eventDate)

  return { fromDate: _eventDate, toDate: undefined, eventDate: _eventDate }
}

const handleFlightsDates = (
  fromDate?: string,
  toDate?: string,
  flightDealType?: EFlightDealType,
  dealType?: EDealType,
) => {
  if (!flightDealType && dealType !== EDealType.Packages) {
    return null
  }

  if (!fromDate) {
    return null
  }

  const _fromDate = parseISO(fromDate)
  let _toDate: Date | undefined

  if (flightDealType === EFlightDealType.OneWay) {
    _toDate = undefined
  } else if (toDate) {
    _toDate = parseISO(toDate)
  } else {
    _toDate = undefined
  }

  return { fromDate: _fromDate, toDate: _toDate, eventDate: undefined }
}

const handleDomesticDates = (checkIn?: string, checkOut?: string) => {
  if (!checkIn || !checkOut) {
    return null
  }

  const _fromDate = parseISO(checkIn)
  const _toDate = parseISO(checkOut)

  return { fromDate: _fromDate, toDate: _toDate, eventDate: undefined }
}

export const validateAvailabilityAndTransformDates = (args: {
  userJourneyType: EUserJourneyType
  flightDealType?: EFlightDealType
  dealType?: EDealType
  fromDate?: string
  toDate?: string
  eventDate?: string
  checkIn?: string
  checkOut?: string
}) => {
  const { userJourneyType, fromDate, toDate, eventDate, checkIn, checkOut, flightDealType, dealType } = args

  if (userJourneyType === EUserJourneyType.SHOWS) {
    return handleShowsDates(eventDate)
  }

  if (userJourneyType === EUserJourneyType.FLIGHTS) {
    return handleFlightsDates(fromDate, toDate, flightDealType, dealType)
  }

  if (userJourneyType === EUserJourneyType.DOMESTIC) {
    return handleDomesticDates(checkIn, checkOut)
  }

  return null
}
